import { apiClient } from './client';

export const highlightsApi = apiClient.injectEndpoints({
    endpoints: (builder: any) => ({
        getHighlights: builder.query({
            query: (bookId: string) => ({
                url: '/api/highlights',
                method: 'GET',
                params: { book_id: bookId },
            }),
        }),

        addHighlight: builder.mutation({
            query: (highlight: any) => ({
                url: '/api/highlights',
                method: 'POST',
                body: highlight,
            }),
        }),

        deleteHighlight: builder.mutation({
            query: ({
                id,
                bookId,
            }: {
                id: number;
                bookId: string | number;
            }) => ({
                url: '/api/highlights',
                method: 'DELETE',
                body: { id: id, book_id: bookId },
            }),
        }),
    }),
});

export const {
    useGetHighlightsQuery,
    useAddHighlightMutation,
    useDeleteHighlightMutation,
} = highlightsApi;
